import { LoginComponent } from "../components";
import { connect } from "react-redux";
import { GetDataLoginLoginAction, SetDataLoginLoginAction,LoginAction } from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataLogin: state.allLoginReducers.loginReducer.DataLogin,
        isResult: state.allLoginReducers.isResultReducer.isResult,
        ResultLogin: state.allLoginReducers.loginReducer.ResultLogin
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataLogin: () => {
            dispatch(GetDataLoginLoginAction());
        },
        SetDataLogin: (DataLogin) => {
            dispatch(SetDataLoginLoginAction(DataLogin));
        },
        Login: (token) => {
            dispatch(LoginAction(token));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);